import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import pageConfig from '../../config/page.config';
import { AMap } from '../../components/atoms';
import { MHero } from '../../components/molecules';
import { OContactInfo, OContactHouseHold } from '../../components/organisme';
import { setMailInfo, sendMail } from '../../redux/contact/contactActions';
import { changeHead } from '../../redux/head/headActions';

import { AertechBuilding } from '../../assets/images/images';

const mapStateToProps = state => ({
	familyName: state.contact.userInfo.familyName.value,
	name: state.contact.userInfo.name.value,
	tel: state.contact.userInfo.tel.value,
	email: state.contact.userInfo.email.value,
	subject: state.contact.mail.subject.value,
	message: state.contact.mail.message.value,
	isFormValid: state.contact.isFormValid,
});

class ContactHouseHoldPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			familyName: '',
			name: '',
			tel: '',
			email: '',
			subject: '',
			message: '',
			isFormValid: false,
		};

		this.bindHandles();
	}

	componentDidMount() {
		this.props.changeHead({
			id: pageConfig.householdContact.id,
			title: this.props.intl.formatMessage({ id: pageConfig.householdContact.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.householdContact.description }),
			showSocialMedia: true,
		});
	}

	componentWillReceiveProps(props) {
		for (const key in this.state) {
			if (key in props && props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		}
	}

	bindHandles() {
		this.handleFormChange = this.handleFormChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleFormChange(value) {
		this.props.setMailInfo({ ...value });
	}

	handleSubmit() {
		if (this.state.isFormValid) {
			this.props.sendMail();
		}
	}

	render() {
		return (
			<section>
				<MHero
					img={AertechBuilding}
					currentPage="BREAD_CRUMB.CONTACT"
				/>
				<article className="section-xx layout-contact">
					<OContactInfo>
						<OContactHouseHold
							familyName={this.state.familyName}
							name={this.state.name}
							tel={this.state.tel}
							email={this.state.email}
							subject={this.state.subject}
							message={this.state.message}
							isFormValid={this.state.isFormValid}
							onChange={this.handleFormChange}
							onSubmit={this.handleSubmit}
						/>
					</OContactInfo>
				</article>
				<AMap />
			</section >
		);
	}
}

ContactHouseHoldPage.propTypes = {
	setMailInfo: PropTypes.func.isRequired,
	sendMail: PropTypes.func.isRequired,
	changeHead: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, {
	setMailInfo,
	sendMail,
	changeHead,
})(injectIntl(ContactHouseHoldPage)));



// WEBPACK FOOTER //
// ./src/pages/household/contact-household.page.js